module.exports = __webpack_public_path__ + "img/nljug-pin.21cd648b.gif";